import { useEffect, useState } from 'react';
import { useOutletContext, useSearchParams } from 'react-router';
import { DASHBOARD } from '../../../types/enum';
import Home from './home';
import WeightProgress from './weightProgress';
import BodyProgress from './bodyProgress';
import PersonalInfo from './personalInfo';
import Header from './header';
import MeasurementProgress from './measurementProgress';
import Goal from './goal';
import Challenge from './challenge';
import Habit from './habit';
// import AgreementNotification from './agreementNotification';

const Dashboard = () => {
  const {
    user,
    signOut,
    refreshUser,
    dashboardSection,
    handleDashboardSection,
  } = useOutletContext();
  const [searchParams, setSearchParams] = useSearchParams();

  const [title, setTitle] = useState(`Hello ${user?.firstname}`);

  useEffect(() => {
    let targetTitle = '';
    if (dashboardSection === DASHBOARD.HOME) {
      targetTitle = `Hello ${user?.firstname}`;
    }
    if (dashboardSection === DASHBOARD.WEIGHT_PROGRESS) {
      targetTitle = 'Weight Progress';
    }
    if (dashboardSection === DASHBOARD.BODY_PROGRESS) {
      targetTitle = 'Body Progress';
    }
    if (dashboardSection === DASHBOARD.MEASUREMENT_PROGRESS) {
      targetTitle = 'Measurement Progress';
    }
    if (dashboardSection === DASHBOARD.PERSONAL_INFO) {
      targetTitle = 'Personal Info';
    }
    if (dashboardSection === DASHBOARD.GOAL) {
      targetTitle = 'Goal';
    }
    if (dashboardSection === DASHBOARD.CHALLENGE) {
      targetTitle = 'Challenge';
    }
    if (dashboardSection === DASHBOARD.HABIT) {
      targetTitle = 'Daily Habit';
    }
    setTitle(targetTitle);

    const section = searchParams.get('section');
    if (section) {
      const targetSection = DASHBOARD[section.toUpperCase()];
      if (targetSection) {
        handleDashboardSection(targetSection)();
        setSearchParams('');
      }
    }
  }, [dashboardSection]);

  const handleCurrentSection = (section) => () => {
    handleDashboardSection(section)();
  };

  return (
    <div className='pb-24 p-4'>
      <Header
        title={title}
        user={user}
        currentSection={dashboardSection}
        handleCurrentSection={handleCurrentSection}
      />
      {dashboardSection === DASHBOARD.HOME && (
        <Home
          user={user}
          refreshUser={refreshUser}
          handleCurrentSection={handleCurrentSection}
          currentProgram={user ? user.program : []}
        />
      )}
      {dashboardSection === DASHBOARD.WEIGHT_PROGRESS && <WeightProgress />}
      {dashboardSection === DASHBOARD.BODY_PROGRESS && <BodyProgress />}
      {dashboardSection === DASHBOARD.MEASUREMENT_PROGRESS && (
        <MeasurementProgress />
      )}
      {dashboardSection === DASHBOARD.PERSONAL_INFO && (
        <PersonalInfo
          signOut={signOut}
          refreshUser={refreshUser}
        />
      )}
      {dashboardSection === DASHBOARD.GOAL && <Goal user={user} />}
      {dashboardSection === DASHBOARD.CHALLENGE && <Challenge user={user} />}
      {dashboardSection === DASHBOARD.HABIT && <Habit user={user} />}
      {/* <AgreementNotification user={user} /> */}
    </div>
  );
};

export default Dashboard;
